// ==================================================
// Google Analytics 4 v1.0.0 - script tracciamento eventi
//
// Copyright 2026 Doctor Shop Srl
//
// ==================================================

var ga4 = (function () {
    function e_pushGenericEvent(e, m) {
        try {
            dataLayer.push({
                'event': e,
                'method': m
            })
        } catch (e) {

        }
    }

    function e_pushGenericEventPar(e, m, v) {
        try {
            dataLayer.push({
                'event': e,
                [m]: v
            })
        } catch (e) {

        }
    }

    function e_pushEvent(p, event, currency) {
        try {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                'event': event,
                'currency': 'EUR',
                'value': parseFloat(parseFloat(p.price).toFixed(2)),
                'ecommerce': {
                    'items': [{
                        'item_id': p.id,
                        'item_name': p.name,
                        'coupon': p.coupon,
                        'discount': p.discount,
                        'index': p.index,
                        'price': parseFloat(parseFloat(p.price).toFixed(2)),
                        'item_brand': p.brand,
                        'item_category': p.category,                        
                        'item_variant': p.variant,
                        'item_list_name': p.listname,
                        'item_list_id': '',
                        'quantity': parseInt(p.quantity),
                    }]
                }
            });
        } catch (e) {
            console.log(e);
        }
    }

    /**
     * Invia al dataLayer i dati utente (evento formSubmitted) - issue #1440 (Claude)
     * @param {any} u oggetto leadsUserData: email, phone_number, address
     */
    function e_pushLeadsUserData(u) {
        try {
            dataLayer.push({
                'event': 'formSubmitted',
                'leadsUserData': u
            });
        } catch (e) {
            console.log(e);
        }
    }

    function wa() {
        e_pushGenericEvent('click', 'wa');
    }

    function e_pushEventPurchase(o, currency) {
        var items = e_ListToString(o.prodotti);

        try {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                'event': 'purchase',
                'ecommerce': {
                    'transaction_id': String(o.idordine),
                    'value': parseFloat(parseFloat(o.tc).toFixed(2)),
                    'tax': parseFloat(parseFloat(o.tax).toFixed(2)),
                    'shipping': parseFloat(parseFloat(o.shipping).toFixed(2)),
                    'currency': 'EUR',
                    'coupon': o.coupon,
                    'items': items
                }
            });
        } catch (er) { }
    }

    /**
     * 
     * @param {any} p json con l'elenco dei prodotti
     * @param {any} event nome dell'evento scatenato
     * @param {any} currency valuta
     * @param {any} pt tipo di pagamento
     * @param {any} tc valore totale 
     * @param {any} cp codice sconto utilizzato
     */
    function e_pushEventMulti(p, event, currency, pt, tc, cp = "") {
        var items = e_ListToString(p);

        try {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                'event': event,
                'currency': 'EUR',
                'coupon': cp,
                'value': parseFloat(parseFloat(tc).toFixed(2)),
                'payment_type': pt,
                'ecommerce': {
                    items
                }
            });
        } catch (e) { }
    }

    function e_ListToString(l) {
        var list = [];

        try {
            l.forEach(function (i) {
                list.push(
                    {
                        'item_id': i.id,
                        'item_name': i.name,
                        'price': parseFloat(parseFloat(i.price).toFixed(2)),
                        'item_brand': i.brand,
                        'item_category': i.category,
                        'item_variant': i.variant,
                        'item_list_name': i.listname,
                        'quantity': i.quantity
                    }
                );
            });
        } catch (e) {
            console.log(e);
        }

        return list;
    }

    function e_pushSearch(l) {
        var list = [];

        l.results.forEach(function (i, index) {
            list.push(
                {
                    'item_id': i.id,
                    'item_name': i.title,
                    'price': i.price,
                    'item_brand': i.brand,
                    'item_category': i.categories[0],
                    'item_variant': '',
                    'item_list_name': 'Ricerca',
                    'index': index + 1,
                    'quantity': '1'
                }
            );
        });

        try {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                'event': 'view_item_list',
                'ecommerce': {
                    list
                }
            });
        } catch (e) { }
    }

    /**
     * OBSOLETE
     * @param {any} o
     */
    function e_pushPurchase(o) {
        var products = JSON.parse(o.JsonObject);
        var items = e_ListToString(products);
        try {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                'event': 'purchase',
                'ecommerce': {
                    'transaction_id': o.orderid,
                    'value': parseFloat(parseFloat(o.TotaleOrdine).toFixed(2)),
                    'tax': parseFloat(parseFloat(o.Iva).toFixed(2)),
                    'shipping': parseFloat(parseFloat(o.SpeseSpedizione).toFixed(2)),
                    'currency': 'EUR',
                    'items': items
                }
            });
        } catch (e) {
            console.log(e);
        }
    }

    return {
        "e_pushGenericEvent": e_pushGenericEvent,
        "e_pushGenericEventPar": e_pushGenericEventPar,
        "e_pushEvent": e_pushEvent,
        "e_pushEventMulti": e_pushEventMulti,
        "e_pushSearch": e_pushSearch,
        "e_pushPurchase": e_pushEventPurchase,
        "e_pushLeadsUserData": e_pushLeadsUserData,
        "wa": wa
    }
})();